import axios from 'axios';
import { Api } from '../constants/urls';

const getBranchesList = async () => {
  const { data } = await axios.get(Api.GET_BRANCHES_LIST);
  return data;
};

const setConfigToGit = async (branch: string, environment: string, app: string) => {
  await axios.post(Api.SET_CONFIG_TO_GIT, {
    branch,
    env: environment,
    app,
  });
};

export const gitService = {
  getBranchesList,
  setConfigToGit,
};
